import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  assetSubtype: null,
  assetSubtypeList: [],
};

const route = "modules/settings/views/assetSubtype/modals/deleteManageAssetSubtype/redux/slice";

export const manageDeleteManageAssetSubtype = createAsyncThunk("manage/deleteManageAssetSubtype/bulkDeleteAssetSubtype", async (payload, { rejectWithValue }) => {
  try {
    const response = await clientMutation(
      `mutation bulkDeleteAssetSubtype ($ids: [Int!]) {
        result: bulkDeleteAssetSubtype (ids: $ids)
      }`,
      payload,
      endpoints.GRAPHQL_GENERAL_V2
    );

    return { delete: response?.result }

  } catch (exc) {
    ExceptionManager(exc, route, "bulkDeleteAssetSubtype");
    return rejectWithValue(exc);
  }
}
);


const manageDeleteManageAssetSubtypeRedux = createSlice({
  name: "manage/deleteManageAssetSubtype",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalDeleteAssetSubtype(state, action) {
      state.open = true;
      state.assetSubtype = action?.payload?.assetSubtype;
      state.assetSubtypeList = action?.payload?.assetSubtypeList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageDeleteManageAssetSubtype
    builder.addCase(manageDeleteManageAssetSubtype.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageDeleteManageAssetSubtype.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(manageDeleteManageAssetSubtype.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageAssetSubtypeRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteAssetSubtype } = actions;

// Export the reducer, either as a default or named export
export default reducer;